<br>
<div *ngIf="showTabGPS" style="border:solid 1px rgb(0, 0, 0);border-radius:5px;margin:10px;padding:10px;background-color: rgb(242, 242, 242);">
  <h5>Instructions</h5>
  In this tab you can select the boundaries of the scenario.
  The boundaries are defined by contours on the google map<br>
  Each contour is then translated to a sensor level to be displayed (see tab GPS Sensors).
  On the right side you can activate several functions:
  <ul>
    <li><b>Start fresh</b>: This will create a new contour map centered in Charlotte, North Carolina</li>
    <li><b>Load KML file</b>: If you have a KML (see
      <a href="https://developers.google.com/kml/documentation/kml_tut" target="_blank">here</a> for more details on KML files) file you can upload the file and use the contours of the file.
    </li>
    <li><b>Move Center</b>: With this functionality you can move the center of the scenario to a location of your choosing.</li>
    <li><b>Select standard scenario</b>: There are a few scenarios (contours) provided by this application</li>
    <li><b>Copy from another scenario</b>: If you have a scenario where you want to copy the settings.</li>
  </ul>
</div>
<div class="row">
  <div class="col-md-8">
    <div #pagemap2 style="width:100%;height:600px"></div>
  </div>
  <div class="col-md-4">
    <button class="btn btn-info btn-sm" style="float:right;margin-top:5px" (click)="showTabGPS = !showTabGPS">Instructions</button>
    Center coordinates of layout:
    <br>
    Longitude: {{layout.center?.lng | number:'1.5-5'}},
    Latitude: {{layout.center?.lat | number:'1.5-5'}}
    <br>


    <div style="margin-top:10px">
      <sa-select class="inlineform2" [(Id)]="actionid" [title]="'Select an Action'" [options]="actions" (IdChange)="actionHasChanged($event)"></sa-select>
    </div>
    <br>


    <!-- Clear Scenariolayout ------------------------------------------------------------------------->
    <div *ngIf="actionid==1">
      <h5>Confirm to start a new layout</h5>
      Confirming will do the following actions:
      <ul>
        <li>Move the center of the layout to Charlotte, NC</li>
        <li>Create 15 contours around the center</li>
      </ul>
      <b>Note:</b>
      You can then change all settings with other actions!
      <br><br>
      <button class="btn btn-warning" (click)="clearScenario()">Confirm</button><br>
      <br>

    </div>

    <!-- Load from KML file ------------------------------------------------------------------------->
    <div *ngIf="actionid==2">
      <!-- <button style="margin-left:10px" class="btn btn-primary" (click)="showLoadFile = true">Load KML file</button><br> -->
      <br>
      <div style="border:solid 1px gray">
        <filetostring (emitFileAsString)="receiveFileAsString($event)"></filetostring>
        <!-- <button class="btn btn-info btn-sm" (click)="showLoadFile = false">Cancel</button> -->
      </div>
    </div>

    <!-- Center position set or change --------------------------------------------------------------->
    <div *ngIf="actionid==3" style="margin-left:10px">
      <div *ngIf="showChooseNewCenter">
        Select a new spot on the map to define the new center<br>
      </div>
    </div>

    <!--  Standard Scenario -------------------------------------------------------------------------->
    <div *ngIf="actionid==4">
      <sa-select class="inlineform" [(Id)]="standardscenarioid" [title]="'Select a Standard Scenario'" [options]="standardscenarios"></sa-select><br>

      <button class="btn btn-primary" (click)="selectStandardScenario()">Create Scenario</button><br>
    </div>

    <!--  Copy from other scenario -------------------------------------------------------------------------->
    <div *ngIf="actionid==5">
      <sa-select class="inlineform" [(Id)]="copyscenarioid" [title]="'Select a Scenario'" [options]="scenarios">
      </sa-select>
      <button class="btn btn-primary" (click)="copyFromScenario()">Create Scenario</button><br>
    </div>


    <!--  Draw a polygon -------------------------------------------------------------------------->
    <div *ngIf="actionid==6">
      Click on the map all cornerpoints of the contour. A list will appear with the selected locations.<br>
      You can leave the contour open. Once done, click the butotn below.
      Center: Long: {{layout.center?.lng | number:'1.5-5'}},
      Lat: {{layout.center?.lat | number:'1.5-5'}}
      <br>
      <table class="table table-bordered">
        <thead>
          <tr>
            <th>Lat</th>
            <th>Lng</th>
            <th>Delete</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let point of polygon">
            <td>{{point.lat}}</td>
            <td>{{point.lng}}</td>
            <td><button class="btn btn-warning btn-sm" (click)="removepoint(point)">Remove</button></td>
          </tr>
        </tbody>
      </table>
      <br>
      Number of Contours:
      <input style="margin-left:20px" type="range" min="3" max="50" value="8" [(ngModel)]="nContours" /> {{nContours}}<br><br>
      <button class="btn btn-primary btn-sm" (click)="completePolygon()">Draw Contours</button>
      <button style="float:right" class="btn btn-warning btn-sm" (click)="clearPolygon()">Clear</button>
      <br>
    </div>

  </div>
</div>
<br>
<button class="btn btn-info btn-sm" (click)="viewObjects = !viewObjects">View JSON Obects</button>
<div *ngIf="viewObjects" class="row" style="margin-left:20px">
  KML: {{scenario.kmlstring | limitTo: 20}}<br>
  Geometry: {{scenario.geometryJson | limitTo: 20}}<br>
  <div class="row">
    <div class="col-md-6">
      <div>Scenario</div>
      <pre id="json">{{scenario | json}}</pre>
    </div>
    <div class="col-md-6">
      <div>Scenariolayout</div>
      # contours: {{layout.contours.length}}<br>
      # contourdefs: {{layout.contourdefinitions.length}}<br>
      <pre id="json">{{layout | json}}</pre>
    </div>
  </div>
</div>